import { Component } from '@angular/core'
import { ConfigService } from '../../services/config.service'
import { ResearchService } from '../../services/research.service'
import { LanguageService } from '../../services/language.service'

import { Feature } from '../../types'
import { FeatureComponent } from './feature/feature.component'

@Component({
   selector: 'app-debug-sidebar',
   standalone: true,
   imports: [FeatureComponent],
   templateUrl: './debug-sidebar.component.html',
   styles: ''
})

export class DebugSidebarComponent {


   get debugInfo() {
      return JSON.stringify(this.research.debugInfo, null, 1)
   }

   envs: string[] = ['ci', 'preview', 'prod', 'test']

   uiOnlyDebugFeatures: Feature[] = [
      {
         key:'cache',
         description: 'Cache the answer or not',
         featureType: 'DEBUG',
         type: 'boolean',
         change: (val) => this.changeCache(val.toString()),
         value: this.config.debugCache === 'true',
      },
      /*{
         key: 'environment',
         description: 'API environment',
         featureType: 'DEBUG',
         type: 'enum',
         value: this.currentEnvironment,
         change: (val) => this.changeEnv(val.toString()),
         valueOptions: this.envs
      },*/
      {
         key: 'language',
         description: 'UI Language',
         featureType: 'DEBUG',
         type: 'enum',
         value: this.languageService.language,
         change: (val) => this.changeLanguage(val.toString()),
         valueOptions: this.languageService.availableLanguages
      }
   ]

   get debugFeatures() {
      return this.config?.features.filter(f => f.featureType === 'DEBUG')
   }

   get features() {
      return this.config?.features.filter(f => f.featureType === 'FEATURE')
   }

   get showLogs() {
      return this.config.features.find(f => f.key === 'logs')?.value
   }

   get experimentalFeatures() {
      return this.config?.features.filter(f => f.featureType === 'EXPERIMENTAL')
   }

   get currentEnvironment() {
      return this.config?.apiParams['environment'] ?? 'prod'
   }


   get currentQA() {
      return this.research.researchSession?.qandas[this.research.researchSession.qandas.length - 1]?.answer?.id ?? 'no qanda'
   }


   constructor(private research: ResearchService, private languageService: LanguageService, private config: ConfigService){

   }

   changeLanguage(lang: string) {
      this.languageService.changeLanguage(lang)
   }

   changeEnv(env: string) {
      this.config.changeEnv(env)
   }

   changeCache(cache: string) {
      this.config.changeCache(cache)
   }


}
